/**
 * src/components/layout/Header.jsx
 * Header con título de página y breadcrumb opcional.
 */

export function Header({ title, subtitle, action }) {
  return (
    <div style={{
      padding: '20px 28px 18px',
      borderBottom: '1px solid var(--color-border)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      background: 'var(--color-surface)',
      flexShrink: 0,
    }}>
      <div>
        <h1 style={{
          margin: 0, fontSize: '18px', fontWeight: 600,
          color: 'var(--color-text)', letterSpacing: '-0.02em',
        }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{
            margin: '3px 0 0', fontSize: '12px',
            color: 'var(--color-text-3)', fontFamily: 'var(--font-mono)',
          }}>
            {subtitle}
          </p>
        )}
      </div>
      {action && <div>{action}</div>}
    </div>
  )
}
